let Ladda = require('ladda');

const TIMEOUT_LENGTH = 750;

// "spinner" param is a Ladda spinner
// TODO: Should deprecate callback and use promise instead
function hideSpinner(spinner, callback) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            spinner.stop();
            resolve();
            if (typeof (callback) === 'function') {
                callback();
            } else {
                // TODO: WARN callback must be a function
            }
        }, TIMEOUT_LENGTH);
    });
}

function showSpinner(element) {
    let spinner = Ladda.create(element);
    spinner.start();
    return spinner;
}

function stopAllSpinners() {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            Ladda.stopAll();
            resolve();
        }, TIMEOUT_LENGTH);
    });
}

module.exports = {
    hideSpinner,
    showSpinner,
    stopAllSpinners
};